import {
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroupComponentSpacing,
    SelectionPanelGroupLayoutStyle,
    SelectionPanelGroupStyleMode,
    SelectionPanelGroupTheme,
    YesNoSelectionPanelGroup,
} from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';

/** Can be left unanswered. */
export const EntireStructureField = () => {
    const value = useStandardLoanStore((state) => state.loan.entireStructure);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <YesNoSelectionPanelGroup
            id='loanEntireStructure'
            value={value}
            onChange={(entireStructure) => updateLoan({ entireStructure })}
            theme={SelectionPanelGroupTheme.Blue}
            styleMode={SelectionPanelGroupStyleMode.Condensed}
            checkShape={SelectionPanelCheckShape.Circle}
            checkStyle={SelectionPanelCheckStyle.Fill}
            label='Entire Structure'
            layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
            labelWidth='150px'
            wrapPanels={true}
            componentSpacing={SelectionPanelGroupComponentSpacing.StandardSpacing}
        />
    );
};
